import React from 'react'
import { CircleAction } from '../utils/action/Action'
import { BLUE } from '../../utils/colors'
import { ControlButtonProps } from './types'



export const ButtonSwitchCam = ({active, onPress}: ControlButtonProps) => <CircleAction label="Trocar Cam." active={true} iconStyle={active ? undefined : { transform: [{ rotate: "90deg" }] }} color={BLUE} icon="refresh-ccw" onPress={onPress} />